type Props = {
  categories: Array<{
    institutionId?: string
    currentInstitution?: string[]
    selectedInstitution?: string[]
  }>
}

export const parseCategories = ({ categories }: Props) => {
  if (!categories || categories.length === 0) {
    return []
  }

  const result: Array<{
    categoryId: string
    institutionId: string
    specimenTypeId: null
  }> = []

  categories.forEach((specimenData) => {
    const { institutionId, currentInstitution, selectedInstitution } =
      specimenData

    if (!institutionId) {
      return
    }

    // Process current institution categories
    const currentInstitutionCategories =
      currentInstitution?.map((val: string) => {
        const parsed = JSON.parse(val)

        return {
          categoryId: parsed.categoryId,
          institutionId: parsed.institutionId,
          specimenTypeId: null
        }
      }) || []

    // Process selected institution categories
    const selectedInstitutionCategories =
      selectedInstitution?.map((val: string) => {
        const parsed = JSON.parse(val)

        return {
          categoryId: parsed.categoryId,
          institutionId: parsed.institutionId,
          specimenTypeId: null
        }
      }) || []

    result.push(
      ...currentInstitutionCategories,
      ...selectedInstitutionCategories
    )
  })

  return result
}
